// These 5 fields are dual-written into settingsV2.overrides by pom-2-api's
// update-team (any of them present on the request, and different from the
// resolved effective value, becomes a team-level override). Any caller that
// spreads the raw legacy `team.settings` blob into a save meant for something
// else (rename, member add/remove, ...) must strip these first, or it risks
// silently pinning a stale value over a real v2 override or inherited
// group/customer setting.
export const CHECK_ON_ME_LEGACY_KEYS = ['checkOnMeEnabled', 'escalationBehavior', 'defaultContact', 'calendarEnabled', 'contacts'] as const;

export const stripCheckOnMeLegacyFields = (settings: Record<string, any> | undefined): Record<string, any> => {
    const rest = { ...(settings || {}) };
    for (const key of CHECK_ON_ME_LEGACY_KEYS) delete rest[key];
    return rest;
};
